import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@Env/environment';
import { Icon } from './icon.model';
import { DaoGeneric } from '@Services/base/daoService';

@Injectable({
  providedIn: 'root'
})
export class IconService extends DaoGeneric<Icon> {
  private url = `${environment.baseUrl}/api_bdc/icons/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }
}
